import React from 'react';
import { Link } from 'react-router-dom';
import ColumnaBotoneraItem from '../ColumnaBotoneraItem.js';
import * as Fecha from '../../funciones/FuncionesFecha.js';
import styles from '../CuadroListaEditable.module.css';
import styleCols from './TablaEstadiosClubes.module.css';

const TablaEstadiosClubes = (props) => {
  const lista = props.lista;
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  };

  return (
    <React.Fragment>
      <tr className={`${styles.titulos}`} key="0">
        <td className={`${styleCols.nombre}`}>Club</td>
        <td className={`${styleCols.desde}`}>Desde</td>
        <td className={`${styleCols.hasta}`}>Hasta</td>
        <td className={`${styles.editar}`}></td>
      </tr>
      {lista &&
        lista.map((item) => (
          <tr
            className={`${styles.valores} ${esIdElegido(item.club && item.club.id) && styles.elegido}`}
            key={item.club ? item.club.id : item.id}
          >
            <td className={`${styleCols.nombre}`}>
              {item.club && (
                <Link to={'/club/' + item.club.id} target="_blank" rel="noopener noreferrer">
                  {item.club.nombre}
                </Link>
              )}
            </td>
            <td className={`${styleCols.desde}`}>
              {Fecha.CamposToFechaCorta(item.anioDesde, item.mesDesde, item.diaDesde)}
            </td>
            <td className={`${styleCols.hasta}`}>
              {Fecha.CamposToFechaCorta(item.anioHasta, item.mesHasta, item.diaHasta)}
            </td>
            <ColumnaBotoneraItem
              idItem={item.club && item.club.id}
              onEditarItem={onEditarItem}
              onEliminarItem={onEliminarItem}
            />
          </tr>
        ))}
    </React.Fragment>
  );
};

export default TablaEstadiosClubes;
